import { z } from "zod";

export const SupportCaseAttachmentRequestSchema = z.object({
  FileName: z.string(),
  Content: z.string(),
  MimeType: z.string(),
});

export type SupportCaseAttachmentRequestType = z.infer<
  typeof SupportCaseAttachmentRequestSchema
>;
